export default __webpack_public_path__ + "static/Apercu-Bold-d9751540bfc7f1f89748b8280804fafb.woff2";